<template>
  <div class="song">
    <h2>{{ name }} (V{{ currentVersion }}) <a href="#" v-on:click="changeName()"><v-icon class="edit" name="edit-3"></v-icon></a></h2>
    <div class="tags">
      <b-badge v-for="(tag, idy) in tags" :key="idy" variant="info">{{ tag }} <span class="remove-tag" v-on:click="removeTag(tag)"><v-icon class="x-circle" name="x-circle"></v-icon></span></b-badge>
      <b-badge href="#" variant="info" v-on:click="addTag()">+</b-badge>
    </div>
    <div class="container row">
      <div class="versions col-xs-12 col-sm-4 col-md-4 col-lg-4">
        <ul v-for="(version, idx) in files" :key="idx">
          <li v-on:click="loadFile(files.length - idx, version.url)"><span class="version">V{{ files.length - idx }}</span> - <span class="date">{{ new Date(version.time).toLocaleDateString() }} {{new Date(version.time).toLocaleTimeString()}}</span> - <span class="name">{{ version.uploadedBy }}</span></li>
        </ul>
        <div>
          <b-button v-if="this.active" v-b-toggle.collapse-1 size="sm">Add version</b-button>
          <b-collapse id="collapse-1" class="mt-2">
            <b-card>
              <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
              <b-button v-if="!uploading" class="upload-btn" size="small" v-on:click="submitFile()">Upload</b-button>
              <b-button v-if="uploading" disabled class="upload-btn" size="small" v-on:click="submitFile()">Upload <b-spinner class="spinner" small></b-spinner></b-button>
            </b-card>
          </b-collapse>
          <div class="actions">
            <b-button v-if="active" v-on:click="toggleArchive()" size="sm" variant="danger">Archive Song</b-button>
            <b-button v-if="!active" v-on:click="toggleArchive()" size="sm" variant="success">Unarchive Song</b-button>
            <div class="rating" v-on:mouseover="setHoverRating">
              <h6>Rating</h6>
              <b-form-group>
                <b-form-radio-group
                  id="btn-radios-1"
                  v-model="userRating"
                  :options="ratingOptions"
                  buttons
                  size="sm"
                  button-variant="outline-primary"
                  name="radios-btn-default"
                  v-on:input="storeRating"
                ></b-form-radio-group>
              </b-form-group>
              <b-tooltip target="btn-radios-1" placement="top">
                <span v-if="hoverRating === 'saw'"><img class="saw" width="30" alt="logo" src="../assets/saw.png"></span>
                <span v-if="hoverRating !== 'saw'">{{ hoverRating }}</span>
              </b-tooltip>
              <span class="avarage">Avarage: </span>
              <b-badge id="avarage-badge" pill :variant="getVariant(avarageRating)">{{ avarageRating }}</b-badge>
              <b-tooltip target="avarage-badge" placement="bottom" trigger="hover">
                <div v-for="(rating, idx) in allRating" class="all-rating" :key="idx">
                  <span>{{ rating.key }}</span> - <span>{{ rating.rating }}</span>
                </div>
              </b-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div v-if="active" class="comments col-xs-12 col-sm-8 col-md-8 col-lg-8">
        <hr>
        <div v-for="(comment, idx) in Array.from(comments)" class="comment" :key="idx">
          <label>
            <span class="commenter"><img v-bind:src="comment.createdBy.picture" alt="">{{ comment.createdBy.name }} </span>
            <span class="date">{{ new Date(comment.created).toLocaleDateString() }} {{new Date(comment.created).toLocaleTimeString()}} </span>
            <b-badge>{{ comment.version }}</b-badge>
          </label>
          <b-badge v-if="comment.createdBy.name === userData.currentUser.displayName" class="remove" variant="danger" v-on:click="removeComment(comment.created)">X</b-badge>
          {{ comment.comment }}
          <hr>
        </div>
        <label class="commenter"><img v-bind:src="userData.currentUser.photoURL" alt="">{{ userData.currentUser.displayName }}</label>
        <textarea class="comment-input" placeholder="Leave a comment" ref="comment" value=""></textarea>
        <b-button v-on:click="submitComment()">Submit</b-button>
        <p></p>
      </div>
      <div v-if="!active" class="archive-msg col-xs-12 col-sm-8 col-md-8 col-lg-8">
        This song is archived. You need to unarchive it to write comments or upload new versions.
      </div>
    </div>
  </div>
</template>

<style lang="scss">

label {
  width: 100%;
  text-align: left;

}

.remove {
  position: absolute;
  right: 15px;
  cursor: pointer;
}

ul {
  padding: 0;
}

.date {
  font-size: 12px;
}
.name {
  font-size: 12px;
}

.upload-btn {
  margin-top: 3px;

  .spinner {
    margin: 2px;
  }
}

.edit {
  width: 20px;
  cursor: pointer;
}

#collapse-1 {
  overflow: hidden;
}

.actions {
  margin-top: 15px;
}

.rating {
  margin-top: 20px;
  h4 {
    font-weight: bold;
  }
  .avarage {
    font-size: 12px;
  }
}

.play {
  width: 30px;
}

.play-button {
  display: inline-block;
  padding: 5px 20px;
  font-size: 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  margin: 10px 0 15px;
}

.play-button:active {
  background-color: #0056b3;
}

.container {
  margin: 0;

  .versions {
    margin: 25px 0;
    text-align: left;

    ul {
      list-style-type: none;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .comments {

    .commenter {
      font-weight: bold;
      padding-top: 2px;
      img {
        width: 24px;
        height: auto;
        margin: -2px 5px 0 0;
        border-radius: 12px;
      }
    }

    .comment {
      text-align: left;
      white-space: pre-line;
    }

    .comment-input {
      width: 100%;
      height: 120px;
      margin-bottom: 10px;
    }
  }

  .archive-msg {
    margin-top: 20px;
  }
}
</style>

<script>
import firebase from 'firebase';
import { auth, db, storage, loggedInUser } from '../firebaseConfig'

export default {
  name: 'song',
  data () {
    return {
      readTimeout: null,
      currentVersion: '',
      currentUrl: '',
      active: true,
      name: '',
      created: '',
      uploading: false,
      files: [{
        time: '',
        url: ''
      }],
      tags: {},
      comments: [{
        song: '',
        created: '',
        comment: '',
        version: '',
        createdBy: {
          name: '',
          picture: ''
        }
      }],
      file: '',
      userData: {
          currentUser: {
            displayName: '',
            photoURL: ''
          }
      },
      userRating: 0,
      ratingOptions: [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' }
      ],
      hoverRating: 'No',
      avarageRating: undefined,
      allRating: []
    }
  },
  
  async mounted() {
    const currentUser = await loggedInUser;
    
    // Set comments to read after a timeout
    this.readTimeout = setTimeout(() => {
      // Get a new write batch
      var batch = db.batch();

      for (var i = 0; i < this.comments.length; i++) {
        var ref = db.collection('comments').doc(String(this.comments[i].created));
        var readBy = {};
        readBy[currentUser.uid] = true;
        batch.set(ref, {readBy: readBy}, {merge: true});
      }

      // Commit the batch
      batch.commit();
    }, 2000)
  },
  beforeDestroy() {
    clearTimeout(this.readTimeout);
  },
  async created() {
    const currentUser = await loggedInUser;
    // auth.onAuthStateChanged( user => {
    //   this.$set( this.userData, 'currentUser', user );
    // });
    this.$set( this.userData, 'currentUser', currentUser );
    db.collection('songs').doc(this.$route.params.id).onSnapshot(doc => {
      if (doc.exists) {
          const allRating = doc.data().rating ? doc.data().rating : {};
          this.active = doc.data().active;
          this.name = doc.data().name;
          this.created = doc.data().created;
          this.tags = doc.data().tags;
          this.files = doc.data().files.reverse();
          this.userRating = allRating[currentUser.displayName] ? allRating[currentUser.displayName] : 0;
          this.currentVersion = this.files.length;
          if (!this.currentUrl) {
            this.currentUrl = this.files[0].url;
            this.playSong();
          }
          // Calculate avarage rating
          let people = 0;
          let totalRating = 0;
          for (const key in allRating) {
            if (allRating.hasOwnProperty(key)) {
              people++;
              this.allRating[this.allRating.length] = {key, rating: allRating[key]}
              totalRating += allRating[key];
            }
          }
          this.avarageRating = isNaN(totalRating / people) ? undefined : (totalRating / people).toFixed(1); 
          console.log(this.allRating);
      } else {
          console.log("That song doesn't exist!");
      }
    });
    db.collection('comments').where("song", "==", this.$route.params.id)
    .onSnapshot(querySnapshot => {
        this.comments = [];
        querySnapshot.forEach(doc => {
          // console.log(doc.data());
          // this.comments.set(doc.id, doc.data());
          this.comments[this.comments.length] = doc.data();
        });
    })

  },
  methods: {
    playSong() {
      const trackUrl = this.currentUrl;
      const title = this.name;
      const route = this.$route;
      this.$store.dispatch('playTrack', {trackUrl, title, route});
    },
    forceFileDownload(response){
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'test') //or any other extension
      document.body.appendChild(link)
      link.click()
    },
    loadFile(version, url) {
      this.currentVersion = version;
      this.currentUrl = url;
      this.playSong();
    },
    async submitFile() {
      const currentUser = await loggedInUser;

      if (!this.file.name) return;

      this.uploading = true;
      // Create a root reference
      const storageRef = storage.ref();
      const timeStamp = new Date().getTime();
      const arr = this.file.name.split('.');
      const ext = arr[arr.length - 1];
      const fileName = timeStamp + '_' + this.name + '.' + ext;
      const songRef = storageRef.child('songs/' + this.$route.params.id + '/');
      // upload song
      songRef.child(fileName).put(this.file).then(uploadsnap => {
        // get download url
        return uploadsnap.ref.getDownloadURL().then(downloadURL => {
          // Add file to tb
          return db.collection('songs').doc(this.$route.params.id).update({
            lastUpdated: timeStamp,
            files: firebase.firestore.FieldValue.arrayUnion({
              time: timeStamp,
              url: downloadURL,
              uploadedBy: currentUser.displayName
            })
          }).then(() => {
            // console.log('all ok');
            // Null all
            const input = this.$refs.file;
            input.type = 'text';
            input.type = 'file';
            this.uploading = false;
            this.file = '';
            this.loadFile(this.currentVersion, downloadURL)
          })
        });
      }).catch(error => {
          console.error('Error adding new file: ', error);
          this.uploading = false;
      });
    },
    handleFileUpload(){
      this.file = this.$refs.file.files[0];
    },
    async submitComment() {
      const currentUser = await loggedInUser;
      console.log(currentUser);
      const timeStamp = new Date().getTime();
      return db.collection('comments').doc(String(timeStamp)).set({
        song: this.$route.params.id,
        created: timeStamp,
        comment: this.$refs.comment.value,
        version: this.currentVersion,
        readBy: {},
        createdBy: {
          name: currentUser.displayName,
          picture: currentUser.photoURL || '',
          uid: currentUser.uid
        }
      }).then(() => {
        this.$refs.comment.value = '';
        // console.log('comment added');
      })
    },
    removeComment(id) {
      db.collection('comments').doc(String(id)).delete().then(function() {
        console.log('Document successfully deleted!');
      }).catch(function(error) {
        console.error('Error removing document: ', error);
      });
    },
    changeName() {
      var newName = prompt('New name', this.name);

      if (newName !== null && newName !== '') {
        const timeStamp = new Date().getTime();
        return db.collection('songs').doc(this.$route.params.id).update({
          lastUpdated: timeStamp,
          name: newName
        });
      }
    },
    addTag() {
      var newTag = prompt('New tag', '');

      if (newTag !== null && newTag !== '') {
        return db.collection('songs').doc(this.$route.params.id).update({
          tags: firebase.firestore.FieldValue.arrayUnion(newTag)
        });
      }
    },
    removeTag(tag) {
      return db.collection('songs').doc(this.$route.params.id).update({
        tags: firebase.firestore.FieldValue.arrayRemove(tag)
      });
    },
    toggleArchive() {
      const msg = this.active ? 'Archive this song?' : 'Unarchive this song?'
      const archive = confirm(msg)

      if (archive) {
        return db.collection('songs').doc(this.$route.params.id).update({
          active: !this.active
        });
      }
    },
    setHoverRating(e) {
      if (e.toElement.control) {
        // const id = new RegExp(/(?<=btn-radios-1__BV_option_)[^\/.]/).exec(e.toElement.control.id)[0];
        const id = e.toElement.control.id.charAt(e.toElement.control.id.indexOf('btn-radios-1__BV_option_') + 24);
        if (id <= 4) {
          this.hoverRating = ['saw', 'Bra, men fillervarning', 'Bra!', 'Ska helt klart med!', 'Ta mig på fittan vad bra!'][id];
        }
      }
    },
    async storeRating() {
      const currentUser = await loggedInUser;
      var batch = db.batch();
      var ref = db.collection('songs').doc(this.$route.params.id);
      let rating = {};
      rating[currentUser.displayName] = this.userRating;
      batch.set(ref, {rating: rating}, {merge: true});
      // Commit the batch
      batch.commit();
    },
    getVariant(nr) {
       if (nr <= 1) return 'danger';
       else if (nr <= 2) return 'warning';
       else if (nr <= 3) return 'secondary';
       else if (nr <= 4) return 'primary';
       else return 'success';
    }
  }
}
</script>